import { render } from "./ModalCloseIcon.vue?vue&type=template&id=400aaff1&scoped=true"
import script from "./ModalCloseIcon.vue?vue&type=script&lang=js"
export * from "./ModalCloseIcon.vue?vue&type=script&lang=js"

import "./ModalCloseIcon.vue?vue&type=style&index=0&id=400aaff1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-400aaff1"

export default script